import {
  Component,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { getSelectedPeriods } from "src/app/utils/period-utils";
import { PharmaDataService } from "../pharma-data.service";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { GlobalSubheaderDataService } from "src/app/global-subheader/global-subheader-data.service";

@Component({
  selector: "app-drug-sales-analysis",
  templateUrl: "./drug-sales-analysis.component.html",
  styleUrls: ["./drug-sales-analysis.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DrugSalesAnalysisComponent {
  @Input() activeTab;
  defaultPeriodObj = {
    is_annual_selected: true,
    period_basis: {
      abs: {
        from_basis: [
          {
            label: "",
            name: "Y",
            selected: true,
          },
        ],
        to_basis: [
          {
            label: "",
            name: "Y",
            selected: true,
          },
        ],
      },
      rel: {
        from_basis: [
          {
            label: "",
            name: "Y",
            selected: false,
          },
        ],
        to_basis: [
          {
            label: "",
            name: "Y",
            selected: false,
          },
        ],
      },
    },
    basis: [
      {
        label: "Calendar",
        name: "cal",
        selected: false,
      },
      {
        label: "Fiscal",
        name: "fy",
        selected: true,
      },
    ],
    from_to: {
      selected_from: new Date().getFullYear() - 2,
      selected_to: new Date().getFullYear() + 7,
    },
    other_period: [],
    type: [
      {
        label: "Absolute",
        name: "abs",
        selected: true,
      },
      {
        label: "Relative",
        name: "rel",
        selected: false,
      },
    ],
  };
  dataSettings = {
    currency: "",
    periodData: {
      period: getSelectedPeriods(this.defaultPeriodObj, false),
      periodStart: -2,
      periodEnd: 7,
      period_type: "absolute",
      period_basis: "fiscal",
    },
    view_by: ["values"],
    revision: "",
  };
  periodRange = [-2, 7];
  metaReady = false;
  defaultPeriodSubscriber: Subscription;
  routeSubscriber: Subscription;
  onPharmaExcelExportSubscriber: Subscription;
  onSelectedLineItemSubscriber: Subscription;
  cTagId;
  selectedLIValue;
  @Output() downloadPharmaExcel: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private dataService: PharmaDataService,
    private route: ActivatedRoute,
    private globalHeaderDataService: GlobalSubheaderDataService,
  ) {}

  ngOnInit() {
    this.routeSubscriber = this.route.params.subscribe((param) => {
      try {
        if (param.cTagId) {
          this.cTagId = parseInt(param.cTagId);
          this.makeDefaultPeriodCall(this.cTagId);
          this.dataService.logUserAction(
            "DEFAULT_PAGE_LOAD",
            {
              dataSettings: this.dataSettings,
              drugCtag: this.cTagId,
            },
            "BIOPHARMA_DRUG_PAGE",
          );
        } else {
          console.error("Ctagid is mandatory in route param");
        }
      } catch (e) {
        console.error("Invalid ctagid ", e);
      }
    });
    this.onSelectedLineItemSubscriber =
      this.dataService.selectedLineItem.subscribe((value) => {
        this.selectedLIValue = value;
      });
    this.onPharmaExcelExportSubscriber =
      this.globalHeaderDataService.onPharmaExcelExport.subscribe(() => {
        const params = {
          ctagid: this.cTagId,
          currency: this.dataSettings.currency,
          viewby: this.dataSettings.view_by[0],
          revision: this.dataSettings.revision,
          period: this.dataSettings.periodData.period,
          period_type: this.dataSettings.periodData.period_type,
          period_basis: this.dataSettings.periodData.period_basis,
          dpid:
            this.selectedLIValue && this.selectedLIValue["value"]
              ? this.selectedLIValue["value"]
              : null,
        };
        if (this.activeTab === 0) this.downloadPharmaExcel.emit(params);
      });
  }

  makeDefaultPeriodCall(cTagId) {
    this.defaultPeriodSubscriber = this.dataService
      .getDefaultPeriod(cTagId)
      .subscribe((resp: any) => {
        if (resp.status !== "error" && resp.message !== "Data not available") {
          const from = resp.data.from_period;
          const to = resp.data.to_period;

          this.defaultPeriodObj.from_to.selected_from =
            new Date().getFullYear() + from;
          this.defaultPeriodObj.from_to.selected_to =
            new Date().getFullYear() + to;

          this.dataSettings = {
            ...this.dataSettings,
            periodData: {
              ...this.dataSettings.periodData,
              period: getSelectedPeriods(this.defaultPeriodObj, false),
              periodStart: from,
              periodEnd: to,
            },
          };
          this.periodRange = [
            this.dataSettings.periodData.periodStart,
            this.dataSettings.periodData.periodEnd,
          ];

          this.metaReady = true;
        } else {
          console.error(
            `get_drug_periods returned error for ctagId: ${cTagId}`,
          );
        }
      });
  }

  dataSettingsChanged(dataSettingsObj) {
    this.dataSettings = { ...dataSettingsObj };
    this.dataService.logUserAction(
      "GRID_SETTINGS",
      {
        dataSettings: this.dataSettings,
        drugCtag: this.cTagId,
      },
      "BIOPHARMA_DRUG_PAGE",
    );
  }

  ngOnDestroy() {
    if (this.routeSubscriber) {
      this.routeSubscriber.unsubscribe();
    }
    if (this.defaultPeriodSubscriber) {
      this.defaultPeriodSubscriber.unsubscribe();
    }
    if (this.onPharmaExcelExportSubscriber) {
      this.onPharmaExcelExportSubscriber.unsubscribe();
    }
    if (this.onSelectedLineItemSubscriber) {
      this.onSelectedLineItemSubscriber.unsubscribe();
    }
  }
}
